export enum InsurancePolicyStatus {
    ACTIVE = "Lopend",
    TERMINATING = "In opzeg", 
    TERMINATED = "Afgesloten",
    DRAFT = "Ontwerp"
}

export interface InsurancePolicyComponent {
    id: number;
    type: string;
    description?: string;
}

export interface ContactCompany {
    id: number;
    name: string;
    email?: string;
    phone_direct?: string;
}

export interface Company {
    id: number;
    name: string;
    legalForm?: string;
}

export interface Building {
    id: string;
    housenr: string;
    googlePlaceLongAddress?: string;
}

export interface InsurancePolicy {
    id: number;
    name: string;
    description?: string;
    policyNumber: string;
    status: InsurancePolicyStatus;
    startDate?: Date;
    endDate?: Date;
    yearlyPremium?: number;
    coverageAmount?: number;
    exemptionAmount?: number;
    insuranceCompany?: ContactCompany;
    broker?: ContactCompany;
    companies?: Company[];
    buildings?: Building[];
    components?: InsurancePolicyComponent[];
    policyDocumentFileLogIds?: number[];
    premiumPaymentFileLogIds?: number[];
    notes?: string;
    contactPersonName?: string;
    contactPersonEmail?: string;
    contactPersonPhone?: string;
    createdAt: Date;
    updatedAt: Date;
    archived: boolean;
}

export interface PolicyMetrics {
    totalPolicies: number;
    activePolicies: number;
    archivedPolicies: number;
    expiringPolicies: number;
    buildingsWithoutPolicies: number;
    policiesWithoutPayments: number;
}
